export default __webpack_public_path__ + "static/media/Horns of the Darkwretch.940cddd6.jpg";